var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.025,
    viewBox: "0 0 24 23.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-293 -20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_524",
    "data-name": "Rect\\xE1ngulo 524",
    width: 24,
    height: 23,
    transform: "translate(293 20.025)",
    fill: "rgba(255,255,255,0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL0_wght400_GRAD0_opsz48_2_",
    "data-name": "edit_FILL0_wght400_GRAD0_opsz48 (2)",
    d: "M7.883,26.467H9.263l13.9-13.9-1.381-1.381-13.9,13.9Zm19.266-15.25L23.132,7.2,24.45,5.883a1.895,1.895,0,0,1,2.636,0l1.381,1.381a1.895,1.895,0,0,1,0,2.636Zm-1.318,1.318L10.016,28.35H6V24.334L21.814,8.519Zm-3.357-.659-.69-.69,1.381,1.381Z",
    transform: "translate(287.606 14.65)",
    fill: "#5ac1dd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d6ddea98e34d038f39b17889362c7de3.svg";
export { ForwardRef as ReactComponent };